import { mapValues } from "lodash";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeTimestamps = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(removeTimestamps);
    } else if (!obj || typeof obj !== "object") {
      return obj;
    } else if (obj.seconds && obj.nanoseconds !== undefined) {
      return obj.seconds;
    } else {
      return mapValues(obj, (value) => removeTimestamps(value));
    }
  };


export function uuidFromClassification(classification: string): string {
    switch (classification) {
        case "LAGEPLAN":
            return "624cb142-0544-11ea-afe4-6b248fcaee98";
    }
    return "unmapped classification";
}
